import { useEffect } from 'react';
import { Wootric } from '../types';

declare global {
  interface Window {
    wootricSettings: {
      email?: string;
      created_at?: number;
      product_name?: string;
      account_token: string;
      modal_theme?: 'light' | 'dark';
      properties?: { [key: string]: any };
    };
    wootric: (value: string) => void;
  }
}

export function useWootric({
  isEnabled,
  scriptReady,
  accountToken,
  productName = 'Digital Salgsoppgave',
  email,
  createdAt
}: Wootric.Props) {
  useEffect(() => {
    if (
      !isEnabled ||
      !scriptReady ||
      !accountToken ||
      !email ||
      !createdAt ||
      typeof window?.wootric === 'undefined'
    ) {
      return;
    }
    const created_at = Math.floor(new Date(createdAt).getTime() / 1000);
    window.wootricSettings = {
      email,
      created_at,
      product_name: productName,
      account_token: accountToken
    };
    window.wootric('run');
  }, [isEnabled, scriptReady, accountToken, email, createdAt]);
}
